window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


import Vue from 'vue'
import VueAwesomeSwiper, {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.component('swiper', Swiper);
Vue.component('swiper-slide', SwiperSlide);
Vue.use(VueAwesomeSwiper);
Vue.component('categories-swiper', require('./components/CategoriesSwiper.vue').default);
Vue.component('products-swiper', require('./components/ProductsSwiper.vue').default);
Vue.component('main-swiper', require('./components/MainSwiper.vue').default);
Vue.component('contact', require('./components/Contact.vue').default);
Vue.component('faq', require('./components/Faq.vue').default);
Vue.component('relaited-products', require('./components/RelaitedProducts.vue').default);
Vue.component('category-list', require('./components/CategoryList.vue').default);
Vue.component('wishlist', require('./components/Wishlist.vue').default);
Vue.component('search', require('./components/Search.vue').default);
Vue.component('add-to-favorites', require('./components/AddToFavorites.vue').default);
Vue.component('manufacturer-list', require('./components/ManufacturerList.vue').default);
Vue.component('brand-list', require('./components/BrandList.vue').default);
Vue.component('search-header', require('./components/SearchHeader.vue').default);

Vue.filter('str_limit', function (value, size) {
    if (!value) return '';
    value = value.toString();
  
    if (value.length <= size) {
      return value;
    }
    return value.substr(0, size) + '...';
  });

const app = new Vue({
    el: '#app'
});

$(document).ready(function () {

    $('.b_selects_list').on('click', 'a', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });

    $('.request_product').on('submit', function (e) {
        e.preventDefault();
        let $this = $(this),
        $target = $(".form-response"),
        action = $(this).attr('action');
        let data = $(this).serialize();
        $.ajax({
            url: action,
            type: 'POST',
            data: data,
            beforeSend: function() {
                $target.find('.sending').toggleClass('hidden');
            },
            success: function( text ){
                console.log(text);
                if(text == "success"){
                    $this[0].reset();
                    $target.find('.success').toggleClass('hidden');
                    $target.find('.sending').toggleClass('hidden');
                } else {
                    $target.find('.error').toggleClass('hidden').innerHTML(text);
                    $target.find('.sending').toggleClass('hidden');
                    // $target.html("<div class='alert alert-success'><p>"+text+"</p></div>");
                }
            }
        });
    
        return false;
    });
    let sticky = false;
    let mobile = false;
    let burger = false;
    function scroll() {
        sticky = window.scrollY > 50;
        if(sticky) {
            $('.is-sticky').addClass('sticky');
            // console.log('1');
        }else {
            $('.is-sticky').removeClass('sticky');
            // console.log('2');
        }
        // if (this.search) {
          //e.preventDefault(); prevent window scrolling
         // return false;
        // }
    };
    function resize() {
        mobile = window.innerWidth < 1201;
    };

    function computedClass() {
        for (let i = 0; i < this.background_pages.length; i++) {
            if (this.$route.path.includes(this.background_pages[i]) || this.$route.path === '/') {
            return false;
            }
        }
        return true;
    }

    scroll();
    resize();
    window.addEventListener('scroll', scroll);
    window.addEventListener('resize', resize);

    // $('.mobile-nav--close-inner').on('click', 'a', function (event) {
    //     $('.mobile-nav').hide();
    //     alert('s');
    // });
    // $('.header-burger').on('click', 'a', function (event) {
    //     $('.mobile-nav').show();
    // });
    document.querySelectorAll('.mobile-nav--close-inner').forEach(function(item) {
        item.addEventListener('click', function(e) {
            document.querySelector('.mobile-nav').style.display = 'none';
        })
    });
    document.querySelectorAll('.header-burger').forEach(function(item) {
        item.addEventListener('click', function(e) {
            document.querySelector('.mobile-nav').style.display = 'block';
        })
    });

    const DropDowns= ['brands', 'categories', 'manufacturer'];
    let ActiveDropDown = '';
    document.querySelectorAll('.showDrop').forEach(function(item) {
        item.addEventListener('click', function(e) {
            DropDowns.forEach(item => {document.querySelector('#' + item).style.display = 'none'});
            let attr = item.getAttribute('attr-name');
            if(!ActiveDropDown) {
                ActiveDropDown = attr;
                document.querySelector('#' + attr).style.display = 'block';
            }else {
                if(ActiveDropDown !== attr) {
                    ActiveDropDown = attr;
                    document.querySelector('#' + attr).style.display = 'block';
                }else {
                    ActiveDropDown = '';
                }
            }
        })
    });

    const DropDownsMobile= ['categoriesMobile'];
    let ActiveDropDownMobile = '';
    document.querySelectorAll('.showDropMobile').forEach(function(item) {
        item.addEventListener('click', function(e) {
            DropDownsMobile.forEach(item => {document.querySelector('#' + item).style.display = 'none'});
            let attr = item.getAttribute('attr-name');
            if(!ActiveDropDownMobile) {
                ActiveDropDownMobile = attr;
                document.querySelector('#' + attr).style.display = 'block';
            }else {
                if(ActiveDropDownMobile !== attr) {
                    ActiveDropDownMobile = attr;
                    document.querySelector('#' + attr).style.display = 'block';
                }else {
                    ActiveDropDownMobile = '';
                }
            }
        })
    });

    var ignoreClickOnMeElement = document.getElementById('header-menu');

    document.addEventListener('click', function(event) {
        var isClickInsideElement = ignoreClickOnMeElement.contains(event.target);
        if (!isClickInsideElement) {
            DropDowns.forEach(item => {document.querySelector('#' + item).style.display = 'none'});
            ActiveDropDown = '';
        }
    });

    document.querySelectorAll('.header-search').forEach(function(item) {
        item.addEventListener('click', function(e) {
            document.querySelector('.search-block').style.display = 'block';
        })
    });
    document.querySelectorAll('.cs-search--close').forEach(function(item) {
        item.addEventListener('click', function(e) {
            document.querySelector('.search-block').style.display = 'none';
        })
    });

});